import axios from "axios";

/**
 * Deletes a prospect by ID.
 * @param {number} id - The ID of the prospect to delete.
 * @returns {Promise<void>} - Resolves if the prospect is deleted successfully.
 * @throws {Error} - Throws an error if the request fails.
 */
const deleteProspect = async (id: number): Promise<void> => {
  const methodName = "deleteProspect";
  console.log(`DEBUG: Entering frontend method ${methodName} with Prospect ID = ${id}`);

  try {
    const response = await axios({
      method: "POST",
      url: `/api/cantrackv3/DeleteProspect`,
      headers: { "Content-Type": "application/json" },
      data: { id },
    });

    if (response.status === 200) {
      console.log(`DEBUG: Prospect with ID = ${id} deleted successfully.`);
    } else {
      console.error(`DEBUG: Unexpected response for ${methodName}:`, response);
      throw new Error("Unexpected response status from DeleteProspect API.");
    }
  } catch (error) {
    console.error(`DEBUG: Exception occurred in ${methodName}:`, error);
    throw error;
  } finally {
    console.log(`DEBUG: Exiting frontend method ${methodName}`);
  }
};

export default deleteProspect;
